import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { FinanceiroService } from '../financeiro.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { StatusControleLancamento } from '../../../models/statusControleLancamento';
import { FormGroup } from '@angular/forms/src/model';
import { FormBuilder, Validators } from '@angular/forms';
import { Usuario } from '../../../models/usuario';
import { AuthService } from '../../admin/auth.service';
import { Perfil, Perfis } from '../../../models/perfis';

@Component({
  selector: 'sispac-visualizar-prestacao-contas',
  templateUrl: './visualizar-prestacao-contas.component.html',
  styleUrls: ['./visualizar-prestacao-contas.component.css']
})
export class VisualizarPrestacaoContasComponent extends WebPage implements OnInit {
  public idControleLancamento: any;
  public controleLancamento: any;
  public contas: any[];
  public conta: any;
  public saldos: any[];
  public totalSaldos = 0;
  public lancamentos: any[];
  public isLoading: boolean;
  public historicoControle: any[];
  public formAnalise: FormGroup;
  public usuario: Usuario;
  public status = { aprovado: '', reprovado: StatusControleLancamento.IdDevolvidoAjustes };

  constructor(messageService: MessageService,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private _financeiroService: FinanceiroService,
    private arquivoService: ArquivoService,
    private authService: AuthService,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.usuario = this.authService.informacoesUsuario();
    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idControleLancamento = params.get('id');
      }
    });
    this.buildForm();
    // console.log(this.usuario);
  }

  ngOnInit() {
    this.getControleLancamento();
    this.getContaByControleLancamento();
    this.getHistoricoControle();
    this.getSaldos();
    // this.verificaPerfil();
  }


  buildForm() {
    this.formAnalise = this.fb.group({
      idControleLancamentoHistorico: [null],
      idControleLancamento: [this.idControleLancamento],
      idStatusControleLancamento: [null],
      idUsuarioGestaoSS: [this.usuario.IdUsuario],
      descricao: [null],
    });
  }

  verificaPerfil() {
    if (this.controleLancamento !== undefined) {
      if (this.usuario.Perfil === Perfis.AdministrativoUnidadeOperacional) {
        return false;
      } else if (this.usuario.Perfil === Perfis.GestorUnidadeOperacional) {
        if (this.controleLancamento.idStatusControleLancamento.toUpperCase() === StatusControleLancamento.IdEnviadoAnalise.toUpperCase()) {
          this.status.aprovado = StatusControleLancamento.IdAprovadoGestorUnidade;
          return true;
        }
        return false;
      } else if (this.usuario.Perfil === Perfis.AdministrativoDex) {
        if (this.controleLancamento.idStatusControleLancamento === StatusControleLancamento.IdAprovadoGestorUnidade.toLowerCase()) {
          this.status.aprovado = StatusControleLancamento.IdAprovadoAdministrativoDex;
          return true;
        }
        return false;
      } else if (this.usuario.Perfil === Perfis.GestorDex) {
        if (this.controleLancamento.idStatusControleLancamento === StatusControleLancamento.IdAprovadoAdministrativoDex.toLowerCase()) {
          this.status.aprovado = StatusControleLancamento.IdAprovadoGestorDex;
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
  }

  getControleLancamento() {
    this.isLoading = true;
    this._financeiroService.getByIdControleLancamento(this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.controleLancamento = data;
          console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getContaByControleLancamento() {
    this.isLoading = true;
    this._financeiroService.getContaByControleLancamento(this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.contas = data;
          // console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );

  }

  getLancamentoByConta(id) {
    // console.log(id);
    this.conta = id;
    if (id !== undefined && id !== '') {
      this._financeiroService.getLancamentoByIdConta(id, this.idControleLancamento)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            this.lancamentos = data;
            // console.log(data);
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    } else {
      this.lancamentos = [];
    }
  }

  downloadArquivo(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Documento_Enviado_Analise');
  }
  verificarBotaoEditar(id: string) {
    return id.toUpperCase() === StatusControleLancamento.IdCadastrado || id.toUpperCase() === StatusControleLancamento.IdDevolvidoAjustes;
  }

  verificarBotaoExcluir(id: string) {
    return id.toUpperCase() === StatusControleLancamento.IdCadastrado || id.toUpperCase() === StatusControleLancamento.IdDevolvidoAjustes;
  }

  getHistoricoControle() {
    this._financeiroService.getHistorico(this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.historicoControle = data;
          // console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  excluir(idLancamento:any){
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excuir este registro?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {

        this._financeiroService.excluirLancamento(idLancamento,this.usuario.IdUsuario)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              this.messageService.add({ severity: 'success', summary: 'Atenção', detail: 'Lançamento excluido com sucesso!' });

              this.getLancamentoByConta(this.conta);
            },
            error => {
              this.gerenciaErro(error);
            }
          );
      }
      });
  }

  aprovar() {
    this.formAnalise.patchValue({ idStatusControleLancamento: this.status.aprovado });
    // console.log(this.formAnalise.value);
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja aprovar esta prestação de contas?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this._financeiroService.cadastrarHistoricoLancamento(this.formAnalise.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              localStorage.setItem('mensagem', 'Cadastro realizado com sucesso!');
              this.router.navigate(['/gerenciar-prestacao-conta']);
            },
            error => {
              this.gerenciaErro(error);
            }
          );
      },
      reject: () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  devolver() {
    this.formAnalise.patchValue({ idStatusControleLancamento: this.status.reprovado });
    // console.log(this.formAnalise.value);
    if (this.formAnalise.value.descricao === null && this.formAnalise.value.descricao === '') {
      return;
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja devolver para ajustes esta prestação de contas?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this._financeiroService.cadastrarHistoricoLancamento(this.formAnalise.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              localStorage.setItem('mensagem', 'Cadastro realizado com sucesso!');

              this.router.navigate(['/gerenciar-prestacao-conta']);
            },
            error => {
              this.gerenciaErro(error);
            }
          );
      },
      reject: () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  getSaldos() {
    this._financeiroService.getByControleLancamento(this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.saldos = data;
          // this.saldos.forEach(x => {
          //   this.totalSaldos += x.valor;
          // });
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/gerenciar-prestacao-conta']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/visualizar-prestacao-contas/visualizar-prestacao-contas.component.ts